/* src/app/ai-sourcing/insights-sidebar/insights-sidebar.component.scss */
.insights-sidebar {
  border-radius: 16px;
  background-color: #ffffff;
  padding: 24px 20px;
  height: 100vh;
}
.insights-sidebar h1 {
  font-size: 14px;
  font-weight: 600;
  color: #E54F7A;
  line-height: 1;
  margin-bottom: 0;
}
.insights-sidebar hr {
  border-top: 1px solid #D9D9D9;
}
.insights-sidebar .step-line {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  position: relative;
  align-items: flex-start;
}
.insights-sidebar .step-line .step-icon {
  color: #969696;
  font-size: 12px;
  margin-right: 8px;
}
.insights-sidebar .step-line .step-text {
  font-size: 12px;
  line-height: 1.5;
  color: #969696;
}
.insights-sidebar .step-line::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 16px;
  width: 1px;
  height: 16px;
  border-left: 1px dashed #969696;
}
.insights-sidebar .step-line:last-child::before {
  display: none;
}
.insights-sidebar .evaluation-card-header {
  font-size: 20px;
  font-weight: 600;
  color: #2E93A1;
  line-height: 1;
  margin-bottom: 20px;
  display: flex;
}
.insights-sidebar .evaluation-card-header span {
  font-size: 21px;
  margin-right: 10px;
}
.insights-sidebar .evaluation-card-header p {
  margin-bottom: 0;
}
.insights-sidebar h1.whatnext {
  font-size: 14px;
  font-weight: 600;
  color: #2E93A1;
  line-height: 1;
}
.insights-sidebar .next-line {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
  position: relative;
}
.insights-sidebar .next-line .next-icon {
  color: #484b59;
  font-size: 12px;
  margin-right: 8px;
}
.insights-sidebar .next-line .next-text {
  font-size: 12px;
  line-height: 1;
  color: #484b59;
}
.gradientbtn {
  padding: 7px 12px 7px 12px;
  border-radius: 4px;
  background-image:
    linear-gradient(
      49deg,
      #c845ab 13%,
      #e24e7f 60%);
  color: #ffffff;
}
.textBox {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.textBox2 {
  max-height: 70px;
  overflow: hidden;
}
.viewMore {
  overflow: visible;
  -webkit-line-clamp: unset;
}
.viewMore2 {
  overflow: visible;
  height: auto;
  max-height: unset;
}
.gen-ai-text {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #484B59;
  cursor: pointer;
  transition: background-color 0.3s ease;
  line-height: 1.5;
}
.feature-item:hover {
  background-color: #EEF9FF;
}
.icon {
  width: 40px;
  height: 40px;
  background: #EEF9FF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 18px;
  color: #2E93A1;
  padding: 0px 16px 0px 16px;
}
.external-link {
  margin-left: auto;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: #2c2c2c;
}
.feature-item:hover .external-link {
  opacity: 1;
  color: #2E93A1;
}
/*# sourceMappingURL=insights-sidebar.component-2BVJKYI2.css.map */
